import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

import './plugins/vuetify';
import './plugins/apexcharts';
import './plugins/toasted';

import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
